import vmClient from 'app/services/vmClient';
import { Entity, IEntityType } from 'app/types/entity';
import { ALL_TRANSLATIONS } from 'app/constants/schemas/translations';
import {
  IOrganization,
  IOrganizationAssociations,
  IOrganizationAttributes,
  OrganizationAssociationDefintions,
  OrganizationAttributeDefinitions,
  OrganizationTranslations,
} from 'app/constants/schemas/Organization';
import { DateMarshaller } from './Date';

export interface IOrganizationDetails extends IOrganization {
  attributes: IOrganizationAttributes & {
    notes: string | null;
    contactEmail: string | null;
    createdAt: Date;
    updatedAt: Date;
  };
  associations: IOrganizationAssociations;
}

export type OrganizationDetails = Entity<IOrganizationDetails>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationDetails: IEntityType<IOrganizationDetails> = vmClient.defineClass({
  typeName: 'OrganizationDetails',
  version: 3,
  persisted: true,
  lockable: true,
  attributes: {
    ...OrganizationAttributeDefinitions,
    notes: 'string',
    contactEmail: 'string',
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
    updatedAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
  },
  associations: OrganizationAssociationDefintions,
});

ALL_TRANSLATIONS.set(OrganizationDetails, {
  ...OrganizationTranslations,
  notes: {
    getLabel: (t) => t('entity-fields.OrganizationDetails.notes.label'),
    getDescription: (t) => t('entity-fields.OrganizationDetails.notes.description'),
  },
  contactEmail: {
    getLabel: (t) => t('entity-fields.OrganizationDetails.contactEmail.label'),
    getDescription: (t) => t('entity-fields.OrganizationDetails.contactEmail.description'),
  },
  createdAt: {
    getLabel: (t) => t('entity-fields.OrganizationDetails.createdAt.label'),
  },
  updatedAt: {
    getLabel: (t) => t('entity-fields.OrganizationDetails.updatedAt.label'),
  },
});
